import React, { useState, useContext } from "react";

import { ALL_DIRECTIONS_QUERY } from "../../../graphql/Directions/Directions.graphql";

import {
  AddDirectionForm,
  EditDirectionForm
} from "../../../components/Directions";

import { ModalContext } from "../../../components/ModalProvider";
import DataTable from "../../../components/DataTable";

import { COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";

import DirectionFilters from "./DirectionFilters";
import { getFilterState, saveFilterState } from "../../../utils";

function DirectionsPage() {
  const INITIAL_FILTER_STATE = getFilterState("DIRECTION_FILTERS", {});

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("DIRECTION_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({});
  const { setModalOpen } = useContext(ModalContext);

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={DirectionFilters}
        columns={COLUMNS}
        filters={filters}
        name="Directions"
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Directions"
        onAddClick={() =>
          setModalOpen(true, <AddDirectionForm setModalOpen={setModalOpen} />)
        }
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_DIRECTIONS_QUERY}
        initialSortBy={[
          { id: "OriginLocationId", desc: false },
          { id: "DestinationLocationId", desc: false }
        ]}
        name="Direction"
        where={filters}
        onRowClick={data =>
          setModalOpen(
            true,
            <EditDirectionForm
              RecId={data.RecId}
              direction={data}
              setModalOpen={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
}

export default DirectionsPage;
